// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './Courses.css';

// const courses = [
//   {
//     title: 'Quranic Reading (Nazira)',
//     shortDescription: 'Basics of reading the Quran with correct pronunciation (Tajweed). Suitable for beginners.',
//     fullDescription: 'Our Quranic Reading course focuses on teaching the basics of reading the Quran with correct pronunciation (Tajweed). This course is suitable for beginners who wish to start their journey of Quranic education with a solid foundation in recitation.',
//     image: './images/card1.jpeg'
//   },
//   {
//     title: 'Quranic Memorization (Hifz)',
//     shortDescription: 'Programs focused on memorizing the Quran in its entirety or specific sections.',
//     fullDescription: 'The Quranic Memorization (Hifz) program is designed for those who aspire to memorize the entire Quran or specific sections. Our experienced instructors provide structured memorization techniques and regular review sessions to help students achieve their memorization goals.',
//     image: './images/card3.jpeg'
//   },
//   {
//     title: 'Noorani Qaida',
//     shortDescription: 'Foundational course for learning the basics of Quranic reading and pronunciation.',
//     fullDescription: 'The Noorani Qaida course is designed to help students learn the basics of Quranic reading and pronunciation. It serves as a foundational course that prepares students for more advanced Quranic studies.',
//     image: './images/card4.jpeg'
//   },
//   {
//     title: 'Namaz (Prayer)',
//     shortDescription: 'Guidance on performing Islamic prayers correctly, including the recitations and physical movements.',
//     fullDescription: 'The Namaz course offers detailed guidance on performing Islamic prayers correctly. It covers the recitations and physical movements involved in each prayer, ensuring students can perform their daily prayers with confidence and understanding.',
//     image: './images/card4.jpeg'
//   },
//   {
//     title: 'Tajweed (Proper Pronunciation)',
//     shortDescription: 'Advanced training on the rules of Tajweed to ensure accurate recitation of the Quran.',
//     fullDescription: 'Our Tajweed course offers advanced training on the rules of Tajweed, ensuring accurate and beautiful recitation of the Quran. This course is designed for students who want to refine their pronunciation and adhere to the rules of Quranic recitation.',
//     image: './images/card5.jpeg'
//   },
//   {
//     title: 'Tafseer (Exegesis)',
//     shortDescription: 'Detailed study of the meanings and interpretations of the Quranic verses.',
//     fullDescription: 'Our Tafseer course involves a detailed study of the meanings and interpretations of the Quranic verses. It includes both classical and contemporary Tafseer to provide students with a comprehensive understanding of the Quranic text.',
//     image: './images/card6.jpeg'
//   },
//   {
//     title: 'Fiqh (Islamic Jurisprudence)',
//     shortDescription: 'Courses on Islamic law derived from the Quran and Hadith, covering practical aspects of worship, transactions, and personal conduct.',
//     fullDescription: 'The Fiqh course covers Islamic law derived from the Quran and Hadith, addressing practical aspects of worship, transactions, and personal conduct. Students gain insights into the application of Islamic principles in various aspects of daily life.',
//     image: './images/card7.jpeg'
//   },
//   {
//     title: 'Hadith Studies',
//     shortDescription: 'Examination of the sayings and actions of Prophet Muhammad (PBUH) and their application in understanding the Quran.',
//     fullDescription: 'The Hadith Studies course examines the sayings and actions of Prophet Muhammad (PBUH) and their relevance in understanding the Quran. Students learn how Hadiths complement and elucidate Quranic teachings.',
//     image: './images/card8.jpeg'
//   },
//   {
//     title: 'Prophet’s Life (Seerah)',
//     shortDescription: 'Detailed study of the life and character of Prophet Muhammad (PBUH) and his interactions with the Quran.',
//     fullDescription: 'The Seerah course provides a detailed study of the life and character of Prophet Muhammad (PBUH). It explores his interactions with the Quran and how his life exemplifies the teachings of the Quran.',
//     image: './images/card9.jpeg'
//   },
//   {
//     title: 'Aqidah (Islamic Beliefs)',
//     shortDescription: 'Courses on core Islamic beliefs, including faith in Allah, Prophets, Angels, and the Hereafter.',
//     fullDescription: 'Our Aqidah course covers core Islamic beliefs, including faith in Allah, Prophets, Angels, and the Hereafter. It provides students with a solid foundation in Islamic theology and understanding of key aspects of faith.',
//     image: './images/card10.jpeg'
//   },
//   {
//     title: 'Islamic History',
//     shortDescription: 'Overview of significant historical events in Islamic history and their impact on the Quranic revelations.',
//     fullDescription: 'The Islamic History course provides an overview of significant events in Islamic history and their impact on the Quranic revelations. Students gain context on the historical background that influenced the Quranic text.',
//     image: './images/card11.jpeg'
//   },
//   {
//     title: 'Islamic Ethics and Morality',
//     shortDescription: 'Study of Islamic principles of conduct and character, based on Quranic teachings.',
//     fullDescription: 'Our Islamic Ethics and Morality course explores principles of conduct and character based on Quranic teachings. Students learn about ethical behavior, moral values, and how to integrate these principles into their daily lives.',
//     image: './images/card12.jpeg'
//   },

//   {
//     title: 'Dua and Supplication',
//     shortDescription: 'Learning various supplications and their significance, including how to make personal supplications (Dua).',
//     fullDescription: 'Our Dua and Supplication course teaches various supplications and their significance. Students learn how to make personal supplications (Dua) and understand their role in personal and spiritual growth.',
//     image: './images/card14.jpeg'
//   }

 
// ];

// const Courses = () => {
//   const [expandedCourse, setExpandedCourse] = useState(null);

//   const handleReadMore = (index) => {
//     setExpandedCourse(index);
//   };

//   return (
    
//     <div className="courses-container">
      
//       {courses.map((course, index) => (
//         <div key={index} className="course-card">
//           <Link to={`/coursedescription`} className="course-link">
//             <img src={course.image} alt={course.title} className="course-image" />
//             <div className="course-details">
//               <h2>{course.title}</h2>
//               <p>{course.shortDescription}</p>
//               {expandedCourse === index ? (
//                 <div className="course-full-description">
//                   <p>{course.fullDescription}</p>
//                   <button onClick={() => setExpandedCourse(null)}>Show Less</button>
//                 </div>
//               ) : (
//                 <button onClick={() => handleReadMore(index)}>Read More</button>
//               )}
//             </div>
//           </Link>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default Courses;


// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import './Courses.css';

// const Courses = () => {
//   const [expandedCourse, setExpandedCourse] = useState(null);

//   const handleReadMore = (index) => {
//     setExpandedCourse(index);
//   };

//   return (
//     <div className="courses-container">
//       <div className="course-card">
//         <Link to={`/coursedescription`} className="course-link">
//           <img src="./images/card1.jpeg" alt="Quranic Reading (Nazira)" className="course-image" />
//           <div className="course-details">
//             <h2>Quranic Reading (Nazira)</h2>
//             <p>Basics of reading the Quran with correct pronunciation (Tajweed). Suitable for beginners.</p>
//             {expandedCourse === 0 ? (
//               <div className="course-full-description">
//                 <p>Our Quranic Reading course focuses on teaching the basics of reading the Quran with correct pronunciation (Tajweed). This course is suitable for beginners who wish to start their journey of Quranic education with a solid foundation in recitation.</p>
//                 <button onClick={() => setExpandedCourse(null)}>Show Less</button>
//               </div>
//             ) : (
//               <button onClick={() => handleReadMore(0)}>Read More</button>
//             )}
//           </div>
//         </Link>
//       </div>

//       <div className="course-card">
//         <Link to={`/coursedescription`} className="course-link">
//           <img src="./images/card3.jpeg" alt="Quranic Memorization (Hifz)" className="course-image" />
//           <div className="course-details">
//             <h2>Quranic Memorization (Hifz)</h2>
//             <p>Programs focused on memorizing the Quran in its entirety or specific sections.</p>
//             {expandedCourse === 1 ? (
//               <div className="course-full-description">
//                 <p>The Quranic Memorization (Hifz) program is designed for those who aspire to memorize the entire Quran or specific sections. Our experienced instructors provide structured memorization techniques and regular review sessions to help students achieve their memorization goals.</p>
//                 <button onClick={() => setExpandedCourse(null)}>Show Less</button>
//               </div>
//             ) : (
//               <button onClick={() => handleReadMore(1)}>Read More</button>
//             )}
//           </div>
//         </Link>
//       </div>

//       <div className="course-card">
//         <Link to={`/coursedescription`} className="course-link">
//           <img src="./images/card4.jpeg" alt="Noorani Qaida" className="course-image" />
//           <div className="course-details">
//             <h2>Noorani Qaida</h2>
//             <p>Foundational course for learning the basics of Quranic reading and pronunciation.</p>
//             {expandedCourse === 2 ? (
//               <div className="course-full-description">
//                 <p>The Noorani Qaida course is designed to help students learn the basics of Quranic reading and pronunciation. It serves as a foundational course that prepares students for more advanced Quranic studies.</p>
//                 <button onClick={() => setExpandedCourse(null)}>Show Less</button>
//               </div>
//             ) : (
//               <button onClick={() => handleReadMore(2)}>Read More</button>
//             )}
//           </div>
//         </Link>
//       </div>

//       <div className="course-card">
//         <Link to={`/coursedescription`} className="course-link">
//           <img src="./images/card4.jpeg" alt="Namaz (Prayer)" className="course-image" />
//           <div className="course-details">
//             <h2>Namaz (Prayer)</h2>
//             <p>Guidance on performing Islamic prayers correctly, including the recitations and physical movements.</p>
//             {expandedCourse === 3 ? (
//               <div className="course-full-description">
//                 <p>The Namaz course offers detailed guidance on performing Islamic prayers correctly. It covers the recitations and physical movements involved in each prayer, ensuring students can perform their daily prayers with confidence and understanding.</p>
//                 <button onClick={() => setExpandedCourse(null)}>Show Less</button>
//               </div>
//             ) : (
//               <button onClick={() => handleReadMore(3)}>Read More</button>
//             )}
//           </div>
//         </Link>
//       </div>

//       <div className="course-card">
//         <Link to={`/coursedescription`} className="course-link">
//           <img src="./images/card5.jpeg" alt="Tajweed (Proper Pronunciation)" className="course-image" />
//           <div className="course-details">
//             <h2>Tajweed (Proper Pronunciation)</h2>
//             <p>Advanced training on the rules of Tajweed to ensure accurate recitation of the Quran.</p>
//             {expandedCourse === 4 ? (
//               <div className="course-full-description">
//                 <p>Our Tajweed course offers advanced training on the rules of Tajweed, ensuring accurate and beautiful recitation of the Quran. This course is designed for students who want to refine their pronunciation and adhere to the rules of Quranic recitation.</p>
//                 <button onClick={() => setExpandedCourse(null)}>Show Less</button>
//               </div>
//             ) : (
//               <button onClick={() => handleReadMore(4)}>Read More</button>
//             )}
//           </div>
//         </Link>
//       </div>

//       <div className="course-card">
//         <Link to={`/coursedescription`} className="course-link">
//           <img src="./images/card6.jpeg" alt="Tafseer (Exegesis)" className="course-image" />
//           <div className="course-details">
//             <h2>Tafseer (Exegesis)</h2>
//             <p>Detailed study of the meanings and interpretations of the Quranic verses.</p>
//             {expandedCourse === 5 ? (
//               <div className="course-full-description">
//                 <p>Our Tafseer course involves a detailed study of the meanings and interpretations of the Quranic verses. It includes both classical and contemporary Tafseer to provide students with a comprehensive understanding of the Quranic text.</p>
//                 <button onClick={() => setExpandedCourse(null)}>Show Less</button>
//               </div>
//             ) : (
//               <button onClick={() => handleReadMore(5)}>Read More</button>
//             )}
//           </div>
//         </Link>
//       </div>

//       <div className="course-card">
//         <Link to={`/coursedescription`} className="course-link">
//           <img src="./images/card7.jpeg" alt="Fiqh (Islamic Jurisprudence)" className="course-image" />
//           <div className="course-details">
//             <h2>Fiqh (Islamic Jurisprudence)</h2>
//             <p>Courses on Islamic law derived from the Quran and Hadith, covering practical aspects of worship, transactions, and personal conduct.</p>
//             {expandedCourse === 6 ? (
//               <div className="course-full-description">
//                 <p>The Fiqh course covers Islamic law derived from the Quran and Hadith, addressing practical aspects of worship, transactions, and personal conduct. Students gain insights into the application of Islamic principles in various aspects of daily life.</p>
//                 <button onClick={() => setExpandedCourse(null)}>Show Less</button>
//               </div>
//             ) : (
//               <button onClick={() => handleReadMore(6)}>Read More</button>
//             )}
//           </div>
//         </Link>
//       </div>

//       <div className="course-card">
//         <Link to={`/coursedescription`} className="course-link">
//           <img src="./images/card8.jpeg" alt="Hadith Studies" className="course-image" />
//           <div className="course-details">
//             <h2>Hadith Studies</h2>
//             <p>Examination of the sayings and actions of Prophet Muhammad (PBUH) and their application in understanding the Quran.</p>
//             {expandedCourse === 7 ? (
//               <div className="course-full-description">
//                 <p>The Hadith Studies course examines the sayings and actions of Prophet Muhammad (PBUH) and their relevance in understanding the Quran. Students learn how Hadiths complement and elucidate Quranic teachings.</p>
//                 <button onClick={() => setExpandedCourse(null)}>Show Less</button>
//               </div>
//             ) : (
//               <button onClick={() => handleReadMore(7)}>Read More</button>
//             )}
//           </div>
//         </Link>
//       </div>

//       <div className="course-card">
//         <Link to={`/coursedescription`} className="course-link">
//           <img src="./images/card9.jpeg" alt="Prophet’s Life (Seerah)" className="course-image" />
//           <div className="course-details">
//             <h2>Prophet’s Life (Seerah)</h2>
//             <p>Detailed study of the life and character of Prophet Muhammad (PBUH) and his interactions with the Quran.</p>
//             {expandedCourse === 8 ? (
//               <div className="course-full-description">
//                 <p>The Seerah course provides a detailed study of the life and character of Prophet Muhammad (PBUH). It explores his interactions with the Quran and how his life exemplifies the teachings of the Islamic faith.</p>
//                 <button onClick={() => setExpandedCourse(null)}>Show Less</button>
//               </div>
//             ) : (
//               <button onClick={() => handleReadMore(8)}>Read More</button>
//             )}
//           </div>
//         </Link>
//       </div>

//       <div className="course-card">
//         <Link to={`/coursedescription`} className="course-link">
//           <img src="./images/card10.jpeg" alt="Islamic History" className="course-image" />
//           <div className="course-details">
//             <h2>Islamic History</h2>
//             <p>Exploration of key historical events and figures in Islamic history and their impact on the present.</p>
//             {expandedCourse === 9 ? (
//               <div className="course-full-description">
//                 <p>The Islamic History course covers significant historical events and figures in Islam, providing insights into their impact on contemporary Muslim societies. Students explore the evolution of Islamic civilization and its contributions to the world.</p>
//                 <button onClick={() => setExpandedCourse(null)}>Show Less</button>
//               </div>
//             ) : (
//               <button onClick={() => handleReadMore(9)}>Read More</button>
//             )}
//           </div>
//         </Link>
//       </div>

   
//     </div>
//   );
// };

// export default Courses;

import React from 'react';
import './Courses.css';

const Courses = () => {
  return (
    <div className="courses-container">
      {/* Card 1 */}
      <div className="course-card">
  <img src="./images/card1.jpeg" alt="Quranic Reading (Nazira)" className="course-image" />
  <div className="course-details">
    <h2>Quranic Reading (Nazira)</h2>
    <p>Basics of reading the Quran with correct pronunciation (Tajweed). Suitable for beginners.</p>
    <button 
      type="button" 
      className="buttons" 
      data-bs-toggle="modal" 
      data-bs-target="#courseModal1"
    >
      Read More
    </button>
  </div>
</div>

<div className="modal fade" id="courseModal1" tabindex="-1" aria-labelledby="courseModal1Label" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="courseModal1Label">Quranic Reading (Nazira)</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <p><strong>Course Overview:</strong></p>
        <p>Our Quranic Reading (Nazira) course focuses on teaching the basics of reading the Quran with correct pronunciation (Tajweed). This course is designed to provide beginners with a solid foundation in Quranic recitation.</p>

        <p><strong>Course Details:</strong></p>
        <ul>
          <li><strong>Duration:</strong> 12 weeks</li>
          <li><strong>Class Frequency:</strong> Twice a week</li>
          <li><strong>Class Duration:</strong> 1 hour per session</li>
          <li><strong>Prerequisites:</strong> None</li>
        </ul>

        <p><strong>Learning Outcomes:</strong></p>
        <ul>
          <li>Accurate pronunciation of Quranic verses</li>
          <li>Understanding of basic Tajweed rules</li>
          <li>Improved recitation skills</li>
          <li>Confidence in reading the Quran aloud</li>
        </ul>

        <p><strong>Course Structure:</strong></p>
        <ol>
          <li><strong>Introduction to Tajweed:</strong> Basic rules and pronunciation</li>
          <li><strong>Practical Exercises:</strong> Reading Quranic verses with guidance</li>
          <li><strong>Assessment:</strong> Regular recitation practice and feedback</li>
          <li><strong>Review Sessions:</strong> Recap and reinforcement of learned material</li>
        </ol>

        <p><strong>Target Audience:</strong></p>
        <p>This course is ideal for beginners who wish to start learning Quranic recitation with correct pronunciation. It is suitable for all age groups.</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


      <div className="modal fade" id="courseModal1" tabIndex="-1" aria-labelledby="courseModal1Label" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="courseModal1Label">Quranic Reading (Nazira)</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p>Our Quranic Reading course focuses on teaching the basics of reading the Quran with correct pronunciation (Tajweed). This course is suitable for beginners who wish to start their journey of Quranic education with a solid foundation in recitation.</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      {/* Card 2 */}
      <div className="course-card">
  <img src="./images/card2.jpeg" alt="Quranic Memorization (Hifz)" className="course-image" />
  <div className="course-details">
    <h2>Quranic Memorization (Hifz)</h2>
    <p>Programs focused on memorizing the Quran in its entirety or specific sections.</p>
    <button 
      type="button" 
      className="buttons" 
      data-bs-toggle="modal" 
      data-bs-target="#courseModal2"
    >
      Read More
    </button>
  </div>
</div>

<div className="modal fade" id="courseModal2" tabIndex="-1" aria-labelledby="courseModal2Label" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="courseModal2Label">Quranic Memorization (Hifz)</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <p><strong>Course Overview:</strong></p>
        <p>The Quranic Memorization (Hifz) program is meticulously designed for students who aim to memorize the entire Quran or specific sections. This program is tailored to accommodate different learning paces and includes personalized guidance to help achieve memorization goals.</p>

        <p><strong>Course Details:</strong></p>
        <ul>
          <li><strong>Duration:</strong> Varies based on the individual's pace, typically 1-2 years for full memorization</li>
          <li><strong>Class Frequency:</strong> Weekly review sessions and daily practice</li>
          <li><strong>Class Duration:</strong> 1-2 hours per session</li>
          <li><strong>Prerequisites:</strong> Basic Quranic reading skills</li>
        </ul>

        <p><strong>Learning Outcomes:</strong></p>
        <ul>
          <li>Ability to memorize the entire Quran or selected sections</li>
          <li>Improved retention and recall techniques</li>
          <li>Enhanced ability to recite from memory with correct Tajweed</li>
          <li>Personalized feedback and progress tracking</li>
        </ul>

        <p><strong>Course Structure:</strong></p>
        <ol>
          <li><strong>Initial Assessment:</strong> Evaluation of current memorization level and setting goals</li>
          <li><strong>Structured Memorization:</strong> Daily memorization assignments with regular reviews</li>
          <li><strong>Progress Monitoring:</strong> Weekly assessments and feedback sessions</li>
          <li><strong>Final Review:</strong> Comprehensive review of memorized sections and reinforcement</li>
        </ol>

        <p><strong>Target Audience:</strong></p>
        <p>This program is ideal for individuals who are dedicated to memorizing the Quran, whether they are beginners or those who have some memorized sections and wish to complete their memorization. It is suitable for all age groups and levels of experience.</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

      {/* Card 3 */}
      <div className="course-card">
  <img src="./images/card3.jpeg" alt="Noorani Qaida" className="course-image" />
  <div className="course-details">
    <h2>Noorani Qaida</h2>
    <p>Foundational course for learning the basics of Quranic reading and pronunciation.</p>
    <button 
      type="button" 
      className="buttons" 
      data-bs-toggle="modal" 
      data-bs-target="#courseModal3"
    >
      Read More
    </button>
  </div>
</div>

<div className="modal fade" id="courseModal3" tabIndex="-1" aria-labelledby="courseModal3Label" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="courseModal3Label">Noorani Qaida</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <p><strong>Course Overview:</strong></p>
        <p>The Noorani Qaida course is designed for students to master the basics of Quranic reading and pronunciation. It serves as a foundational course that prepares students for more advanced Quranic studies, ensuring that they have a strong grasp of the fundamentals.</p>

        <p><strong>Course Details:</strong></p>
        <ul>
          <li><strong>Duration:</strong> Typically 2-3 months, depending on the student's pace</li>
          <li><strong>Class Frequency:</strong> 2-3 sessions per week</li>
          <li><strong>Class Duration:</strong> 1 hour per session</li>
          <li><strong>Prerequisites:</strong> None; suitable for beginners</li>
        </ul>

        <p><strong>Learning Outcomes:</strong></p>
        <ul>
          <li>Ability to read Quranic text with correct pronunciation</li>
          <li>Understanding of basic Tajweed rules</li>
          <li>Improved reading fluency and accuracy</li>
          <li>Foundation for advanced Quranic studies</li>
        </ul>

        <p><strong>Course Structure:</strong></p>
        <ol>
          <li><strong>Introduction to Qaida:</strong> Overview of the Noorani Qaida and its importance</li>
          <li><strong>Alphabet and Pronunciation:</strong> Learning the Arabic alphabet and correct pronunciation</li>
          <li><strong>Basic Tajweed Rules:</strong> Introduction to basic Tajweed rules for proper recitation</li>
          <li><strong>Practice Sessions:</strong> Guided reading practice with feedback and corrections</li>
          <li><strong>Assessment:</strong> Regular assessments to track progress and address challenges</li>
        </ol>

        <p><strong>Target Audience:</strong></p>
        <p>This course is ideal for beginners who wish to learn Quranic reading from scratch. It is suitable for children as well as adults who are new to Quranic studies and want to build a solid foundation.</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

      {/* Card 4 */}
      <div className="course-card">
  <img src="./images/card4.jpeg" alt="Namaz (Prayer)" className="course-image" />
  <div className="course-details">
    <h2>Namaz (Prayer)</h2>
    <p>Guidance on performing Islamic prayers correctly, including the recitations and physical movements.</p>
    <button 
      type="button" 
      className="buttons" 
      data-bs-toggle="modal" 
      data-bs-target="#courseModal4"
    >
      Read More
    </button>
  </div>
</div>

<div className="modal fade" id="courseModal4" tabIndex="-1" aria-labelledby="courseModal4Label" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="courseModal4Label">Namaz (Prayer)</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <p><strong>Course Overview:</strong></p>
        <p>The Namaz (Prayer) course provides comprehensive instruction on the Islamic practice of daily prayers. This course covers all aspects of Namaz, including the correct recitations, physical movements, and the spiritual significance of each prayer. It aims to ensure that participants perform their prayers accurately and with full understanding.</p>

        <p><strong>Course Details:</strong></p>
        <ul>
          <li><strong>Duration:</strong> 4-6 weeks</li>
          <li><strong>Class Frequency:</strong> 2 sessions per week</li>
          <li><strong>Class Duration:</strong> 1 hour per session</li>
          <li><strong>Prerequisites:</strong> Basic knowledge of Islamic practices is helpful but not required</li>
        </ul>

        <p><strong>Learning Outcomes:</strong></p>
        <ul>
          <li>Understanding the significance and importance of Namaz in Islam</li>
          <li>Ability to perform each of the five daily prayers with the correct recitations and movements</li>
          <li>Knowledge of the different positions and their meanings during the prayer</li>
          <li>Improved ability to focus and engage spiritually during prayers</li>
        </ul>

        <p><strong>Course Structure:</strong></p>
        <ol>
          <li><strong>Introduction to Namaz:</strong> Overview of the significance of daily prayers in Islam</li>
          <li><strong>Recitations:</strong> Detailed instruction on the various recitations performed during the prayer</li>
          <li><strong>Physical Movements:</strong> Demonstrations of the physical postures and their meanings</li>
          <li><strong>Practice Sessions:</strong> Guided practice with feedback on performance</li>
          <li><strong>Q&A and Review:</strong> Sessions for addressing questions and reviewing key points</li>
        </ol>

        <p><strong>Target Audience:</strong></p>
        <p>This course is suitable for individuals who wish to learn or improve their practice of Namaz. It is designed for beginners and those seeking to refine their understanding and performance of Islamic prayers.</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


      {/* Card 5 */}
      <div className="course-card">
  <img src="./images/card5.jpeg" alt="Tajweed (Proper Pronunciation)" className="course-image" />
  <div className="course-details">
    <h2>Tajweed (Proper Pronunciation)</h2>
    <p>Advanced training on the rules of Tajweed to ensure accurate recitation of the Quran.</p>
    <button 
      type="button" 
      className="buttons" 
      data-bs-toggle="modal" 
      data-bs-target="#courseModal5"
    >
      Read More
    </button>
  </div>
</div>

<div className="modal fade" id="courseModal5" tabIndex="-1" aria-labelledby="courseModal5Label" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="courseModal5Label">Tajweed (Proper Pronunciation)</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <p><strong>Course Overview:</strong></p>
        <p>This Tajweed course provides advanced training on the rules of Tajweed, aiming to enhance the beauty and accuracy of Quranic recitation. The course is tailored for students who have a basic understanding of Quranic reading and seek to refine their pronunciation according to Tajweed rules.</p>

        <p><strong>Course Details:</strong></p>
        <ul>
          <li><strong>Duration:</strong> 6-8 weeks</li>
          <li><strong>Class Frequency:</strong> 2 sessions per week</li>
          <li><strong>Class Duration:</strong> 1.5 hours per session</li>
          <li><strong>Prerequisites:</strong> Basic knowledge of Quranic reading and Tajweed fundamentals</li>
        </ul>

        <p><strong>Learning Outcomes:</strong></p>
        <ul>
          <li>In-depth understanding of advanced Tajweed rules and their application</li>
          <li>Improved accuracy and fluency in Quranic recitation</li>
          <li>Ability to identify and correct common pronunciation errors</li>
          <li>Enhanced appreciation for the beauty of proper Quranic recitation</li>
        </ul>

        <p><strong>Course Structure:</strong></p>
        <ol>
          <li><strong>Introduction to Advanced Tajweed:</strong> Review of basic Tajweed concepts and introduction to advanced rules</li>
          <li><strong>Phonetics and Pronunciation:</strong> Detailed study of Arabic phonetics and correct pronunciation of Quranic letters</li>
          <li><strong>Tajweed Rules in Practice:</strong> Application of Tajweed rules in various Quranic verses</li>
          <li><strong>Common Mistakes and Corrections:</strong> Identification of common pronunciation mistakes and techniques for correction</li>
          <li><strong>Recitation Practice:</strong> Guided recitation practice with feedback and corrections</li>
        </ol>

        <p><strong>Target Audience:</strong></p>
        <p>This course is ideal for students who are familiar with the basics of Quranic reading and wish to improve their Tajweed skills. It is suitable for those looking to achieve a higher level of accuracy and beauty in their recitation.</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


      {/* Card 6 */}
      <div className="course-card">
  <img src="./images/card6.jpeg" alt="Tafseer (Exegesis)" className="course-image" />
  <div className="course-details">
    <h2>Tafseer (Exegesis)</h2>
    <p>Detailed study of the meanings and interpretations of the Quranic verses.</p>
    <button 
      type="button" 
      className="buttons" 
      data-bs-toggle="modal" 
      data-bs-target="#courseModal6"
    >
      Read More
    </button>
  </div>
</div>

<div className="modal fade" id="courseModal6" tabIndex="-1" aria-labelledby="courseModal6Label" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="courseModal6Label">Tafseer (Exegesis)</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <p><strong>Course Overview:</strong></p>
        <p>The Tafseer course provides an in-depth study of the meanings and interpretations of Quranic verses. This course is designed to enhance students' understanding of the Quranic text and its relevance to various aspects of daily life and spirituality.</p>

        <p><strong>Course Details:</strong></p>
        <ul>
          <li><strong>Duration:</strong> 10-12 weeks</li>
          <li><strong>Class Frequency:</strong> 2 sessions per week</li>
          <li><strong>Class Duration:</strong> 1.5 hours per session</li>
          <li><strong>Prerequisites:</strong> Basic knowledge of Quranic Arabic and Quranic studies</li>
        </ul>

        <p><strong>Learning Outcomes:</strong></p>
        <ul>
          <li>In-depth understanding of the context and meanings of Quranic verses</li>
          <li>Ability to interpret Quranic texts and apply them to modern-day issues</li>
          <li>Enhanced skills in critical analysis of Quranic literature</li>
          <li>Increased appreciation for the Quranic message and its application in daily life</li>
        </ul>

        <p><strong>Course Structure:</strong></p>
        <ol>
          <li><strong>Introduction to Tafseer:</strong> Overview of Tafseer and its significance in understanding the Quran</li>
          <li><strong>Historical Context:</strong> Study of the historical and cultural context of Quranic revelations</li>
          <li><strong>Major Tafseer Works:</strong> Exploration of classical and contemporary Tafseer literature</li>
          <li><strong>Methodologies of Tafseer:</strong> Examination of various methodologies used in Tafseer and their application</li>
          <li><strong>Practical Application:</strong> Analysis of selected Quranic verses and their application in contemporary issues</li>
        </ol>

        <p><strong>Target Audience:</strong></p>
        <p>This course is ideal for students who have a foundational understanding of Quranic Arabic and seek to deepen their knowledge of Quranic interpretation. It is suited for those interested in religious studies, theology, or anyone looking to gain a more profound understanding of the Quran.</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


      {/* Card 7 */}
      <div className="course-card">
  <img src="./images/card7.jpeg" alt="Islamic History" className="course-image" />
  <div className="course-details">
    <h2>Islamic History</h2>
    <p>Exploration of significant events and figures in Islamic history.</p>
    <button 
      type="button" 
      className="buttons" 
      data-bs-toggle="modal" 
      data-bs-target="#courseModal7"
    >
      Read More
    </button>
  </div>
</div>

<div className="modal fade" id="courseModal7" tabIndex="-1" aria-labelledby="courseModal7Label" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="courseModal7Label">Islamic History</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <p><strong>Course Overview:</strong></p>
        <p>The Islamic History course delves into the significant events and figures that have shaped the course of Islamic civilization. From the early life of the Prophet Muhammad (peace be upon him) to the development of Islamic empires and modern Islamic history, this course provides a comprehensive understanding of the historical context of Islam.</p>

        <p><strong>Course Details:</strong></p>
        <ul>
          <li><strong>Duration:</strong> 12-14 weeks</li>
          <li><strong>Class Frequency:</strong> 2 sessions per week</li>
          <li><strong>Class Duration:</strong> 1.5 hours per session</li>
          <li><strong>Prerequisites:</strong> None required, but basic knowledge of Islamic principles is beneficial</li>
        </ul>

        <p><strong>Learning Outcomes:</strong></p>
        <ul>
          <li>Gain an understanding of key historical events in Islamic history</li>
          <li>Learn about the lives and contributions of significant historical figures</li>
          <li>Understand the development and impact of various Islamic empires and dynasties</li>
          <li>Analyze the influence of historical events on contemporary Islamic societies</li>
        </ul>

        <p><strong>Course Structure:</strong></p>
        <ol>
          <li><strong>The Life of Prophet Muhammad (PBUH):</strong> Study the early life, prophethood, and major events during the Prophet's life</li>
          <li><strong>Early Islamic Caliphates:</strong> Explore the Rashidun, Umayyad, and Abbasid Caliphates and their contributions to Islamic history</li>
          <li><strong>Medieval Islamic Empires:</strong> Examine the rise and fall of various empires such as the Ottoman Empire, Safavid Empire, and Mughal Empire</li>
          <li><strong>Colonial Period and Independence Movements:</strong> Understand the impact of colonialism on the Muslim world and the subsequent movements for independence</li>
          <li><strong>Modern Islamic History:</strong> Analyze contemporary issues, movements, and developments in the Islamic world</li>
        </ol>

        <p><strong>Target Audience:</strong></p>
        <p>This course is suitable for students, researchers, and anyone interested in gaining a deeper understanding of Islamic history. It is particularly beneficial for those studying Islamic studies, history, or related fields.</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


      {/* Card 8 */}
      <div className="course-card">
  <img src="./images/card8.jpeg" alt="Arabic Language" className="course-image" />
  <div className="course-details">
    <h2>Arabic Language</h2>
    <p>Introduction to the Arabic language, focusing on grammar, vocabulary, and conversation skills.</p>
    <button 
      type="button" 
      className="buttons" 
      data-bs-toggle="modal" 
      data-bs-target="#courseModal8"
    >
      Read More
    </button>
  </div>
</div>

<div className="modal fade" id="courseModal8" tabIndex="-1" aria-labelledby="courseModal8Label" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="courseModal8Label">Arabic Language</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <p><strong>Course Overview:</strong></p>
        <p>The Arabic Language course provides an introduction to the Arabic language, focusing on essential grammar, vocabulary, and conversation skills. This course is perfect for beginners and those looking to improve their Arabic proficiency, which is crucial for effective Quranic studies and communication in the Arab world.</p>

        <p><strong>Course Details:</strong></p>
        <ul>
          <li><strong>Duration:</strong> 8-10 weeks</li>
          <li><strong>Class Frequency:</strong> 2 sessions per week</li>
          <li><strong>Class Duration:</strong> 1 hour per session</li>
          <li><strong>Prerequisites:</strong> None required, suitable for beginners</li>
        </ul>

        <p><strong>Learning Outcomes:</strong></p>
        <ul>
          <li>Understand basic Arabic grammar rules and sentence structures</li>
          <li>Expand vocabulary related to everyday conversations and Quranic texts</li>
          <li>Develop conversational skills for effective communication in Arabic</li>
          <li>Enhance reading and writing skills in Arabic script</li>
        </ul>

        <p><strong>Course Structure:</strong></p>
        <ol>
          <li><strong>Introduction to Arabic Script:</strong> Learn the Arabic alphabet, pronunciation, and basic writing skills</li>
          <li><strong>Basic Grammar:</strong> Study fundamental grammar rules including noun-adjective agreement, verb conjugations, and sentence structure</li>
          <li><strong>Vocabulary Building:</strong> Acquire vocabulary for everyday conversations and Quranic terminology</li>
          <li><strong>Conversational Skills:</strong> Practice speaking and listening through interactive exercises and dialogues</li>
          <li><strong>Reading and Writing:</strong> Develop skills to read and write simple Arabic texts and passages</li>
        </ol>

        <p><strong>Target Audience:</strong></p>
        <p>This course is ideal for anyone interested in learning Arabic for personal, academic, or professional reasons. It is particularly beneficial for those studying the Quran, traveling to Arabic-speaking countries, or working in environments where Arabic is used.</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


      {/* Card 9 */}
      <div className="course-card">
  <img src="./images/card9.jpeg" alt="Islamic Jurisprudence (Fiqh)" className="course-image" />
  <div className="course-details">
    <h2>Islamic Jurisprudence (Fiqh)</h2>
    <p>Comprehensive study of Islamic legal principles and their application in daily life.</p>
    <button 
      type="button" 
      className="buttons" 
      data-bs-toggle="modal" 
      data-bs-target="#courseModal9"
    >
      Read More
    </button>
  </div>
</div>

<div className="modal fade" id="courseModal9" tabIndex="-1" aria-labelledby="courseModal9Label" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="courseModal9Label">Islamic Jurisprudence (Fiqh)</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <p><strong>Course Overview:</strong></p>
        <p>The Islamic Jurisprudence (Fiqh) course offers an in-depth examination of Islamic legal principles and their practical application. Students will explore the foundations of Islamic law, including its sources, methodologies, and the application of these principles to various aspects of daily life.</p>

        <p><strong>Course Details:</strong></p>
        <ul>
          <li><strong>Duration:</strong> 12-14 weeks</li>
          <li><strong>Class Frequency:</strong> 1-2 sessions per week</li>
          <li><strong>Class Duration:</strong> 1.5 hours per session</li>
          <li><strong>Prerequisites:</strong> Basic understanding of Islamic teachings is recommended</li>
        </ul>

        <p><strong>Learning Outcomes:</strong></p>
        <ul>
          <li>Understand the primary sources of Islamic law, including the Quran and Sunnah</li>
          <li>Gain insight into the principles of Ijtihad (legal reasoning) and its role in Islamic jurisprudence</li>
          <li>Apply Islamic legal principles to practical issues such as transactions, personal conduct, and family law</li>
          <li>Analyze historical and contemporary legal rulings and their implications</li>
        </ul>

        <p><strong>Course Structure:</strong></p>
        <ol>
          <li><strong>Introduction to Islamic Jurisprudence:</strong> Overview of Fiqh, its sources, and methodologies</li>
          <li><strong>Sources of Islamic Law:</strong> Detailed study of the Quran, Hadith, Ijma' (consensus), and Qiyas (analogy)</li>
          <li><strong>Legal Reasoning and Ijtihad:</strong> Principles and processes of legal reasoning and interpretation</li>
          <li><strong>Practical Applications:</strong> Application of Fiqh to daily life issues, including personal and family law</li>
          <li><strong>Historical Context:</strong> Examination of historical developments in Islamic jurisprudence and their impact</li>
        </ol>

        <p><strong>Target Audience:</strong></p>
        <p>This course is aimed at individuals interested in understanding Islamic law and its application. It is suitable for students, legal professionals, and anyone seeking to deepen their knowledge of Islamic jurisprudence and its relevance to contemporary issues.</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


      {/* Card 10 */}
     <div className="course-card">
  <img src="./images/card10.jpeg" alt="Hadith Studies" className="course-image" />
  <div className="course-details">
    <h2>Hadith Studies</h2>
    <p>Study of the sayings, actions, and approvals of the Prophet Muhammad (PBUH).</p>
    <button 
      type="button" 
      className="buttons" 
      data-bs-toggle="modal" 
      data-bs-target="#courseModal10"
    >
      Read More
    </button>
  </div>
</div>

<div className="modal fade" id="courseModal10" tabIndex="-1" aria-labelledby="courseModal10Label" aria-hidden="true">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="courseModal10Label">Hadith Studies</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
        <p><strong>Course Overview:</strong></p>
        <p>The Hadith Studies course provides an in-depth exploration of the sayings, actions, and approvals of the Prophet Muhammad (PBUH). This course aims to enhance understanding of Hadith literature, its classification, and its impact on Islamic teachings and jurisprudence.</p>

        <p><strong>Course Details:</strong></p>
        <ul>
          <li><strong>Duration:</strong> 10-12 weeks</li>
          <li><strong>Class Frequency:</strong> 1-2 sessions per week</li>
          <li><strong>Class Duration:</strong> 1.5 hours per session</li>
          <li><strong>Prerequisites:</strong> Basic knowledge of Islamic teachings is recommended</li>
        </ul>

        <p><strong>Learning Outcomes:</strong></p>
        <ul>
          <li>Understand the principles of Hadith classification and authentication</li>
          <li>Gain insights into the historical context of Hadith and its compilation</li>
          <li>Analyze various Hadith collections and their contributions to Islamic jurisprudence</li>
          <li>Apply Hadith studies to contemporary issues and Islamic practice</li>
        </ul>

        <p><strong>Course Structure:</strong></p>
        <ol>
          <li><strong>Introduction to Hadith:</strong> Overview of Hadith literature and its significance</li>
          <li><strong>Classification of Hadith:</strong> Study of different categories and authenticity criteria</li>
          <li><strong>Major Hadith Collections:</strong> Examination of key collections such as Sahih Bukhari, Sahih Muslim, etc.</li>
          <li><strong>Historical Context:</strong> Exploration of the historical development and compilation of Hadith</li>
          <li><strong>Application of Hadith:</strong> Discussion on how Hadith is used in Islamic jurisprudence and daily life</li>
        </ol>

        <p><strong>Target Audience:</strong></p>
        <p>This course is designed for individuals interested in deepening their understanding of Hadith literature. It is suitable for students, scholars, and anyone eager to explore the teachings and practices of the Prophet Muhammad (PBUH).</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

    </div>
  );
};

export default Courses;
